exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.uploader[data-v-01558445]{margin:0 auto;width:56px;height:56px;position:relative\n}\n.uploader .md-fab[data-v-01558445]{margin:0\n}\n.uploader .md-spinner[data-v-01558445]{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)\n}\n.uploader .md-icon[data-v-01558445]{margin:0 !important;top:50%;left:47% !important;transform:translate(-50%, -50%)\n}\n.imageContainer[data-v-01558445]{display:flex;justify-content:center;width:100%\n}\n.imageContainer img[data-v-01558445]{width:300px\n}\n.massageInfo[data-v-01558445]{font-style:italic;color:gray;font-weight:500\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-01558445","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/upload/DistributionPoster.vue
// module id = 151
// module chunks = 0